<template>
  <h3 class="formtitle">
    <span>{{ titleText }}</span>
  </h3>
</template>

<script>
export default {
  name: 'FormTitle',
  props: {
    titleText: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.formtitle {
  position: relative;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 10px;
  span {
    padding: 0 10px;
    background-color: $white;
    &:after {
      display: block;
      content: '';
      top: 50%;
      width: 100%;
      position: absolute;
      border: 1px solid $border-gentle;
      z-index: -1;
    }
  }
}
</style>
